
import { TOGGLE_FEATURE_EDITOR, CHECKED_FEATURE_FLAG, SET_FEATURE_FLAG } from 'actions'

const initialState = {
  isShowingEditor: false,
  data: {}
}

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case TOGGLE_FEATURE_EDITOR:
      return {
        ...state,
        isShowingEditor: !state.isShowingEditor
      }
    case CHECKED_FEATURE_FLAG:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.featureId]: payload.result
        }
      }
    case SET_FEATURE_FLAG:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.id]: payload.value
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/application/features.js